const swiper = new Swiper(".swiper-container", {
  direction: 'horizontal',
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 10,
  
  breakpoints: {
    749: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  }
});